import React from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import Pixel from '../Meta/Pixel';

import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import StepConnector from '@material-ui/core/StepConnector';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';

import { PersonalDetailsPage } from '../PersonalDetailsPage';
import AppStore from '../../Resources/app-store.png';
import PlayStore from '../../Resources/play-store.png';
import { useAlert } from 'react-alert';
import ReactLoading from 'react-loading';


const useQontoStepIconStyles = makeStyles({
    root: {
      color: '#eaeaf0',
      display: 'flex',
      height: 22,
      alignItems: 'center',
    },
    active: {
      color: '#784af4',
    },
    circle: {
      width: 8,
      height: 8,
      borderRadius: '50%',
      backgroundColor: 'currentColor',
    },
    completed: {
      color: '#784af4',
      zIndex: 1,
      fontSize: 18,
    },
  });
  
  function QontoStepIcon(props) {
    const classes = useQontoStepIconStyles();
    const { active } = props;
  
    return (
      <div
        className={clsx(classes.root, {
          [classes.active]: active,
        })}
      >
      </div>
    );
  }
  
  QontoStepIcon.propTypes = {
    /**
     * Whether this step is active.
     */
    active: PropTypes.bool,
    /**
     * Mark the step as completed. Is passed to child components.
     */
    completed: PropTypes.bool,
  };
  
  const ColorlibConnector = withStyles({
    alternativeLabel: {
      top: 22,
    },
    active: {
      '& $line': {
          background: '#003566',
      //   backgroundImage:
      //     'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
      },
    },
    completed: {
      '& $line': {
          background: '#003566',
      //   backgroundImage:
      //     'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
      },
    },
    line: {
      height: 3,
      border: 0,
      backgroundColor: '#eaeaf0',
      borderRadius: 1,
    },
  })(StepConnector);
  
  const useColorlibStepIconStyles = makeStyles({
    root: {
      backgroundColor: '#ccc',
      zIndex: 1,
      color: '#fff',
      width: 50,
      height: 50,
      display: 'flex',
      borderRadius: '50%',
      justifyContent: 'center',
      alignItems: 'center',
    },
    active: {
      // backgroundImage:
      //   'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
      background: '#003566',
      boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
    },
    completed: {
      // backgroundImage:
      //   'linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)',
      background: '#003566',
    },
  });
  
  function ColorlibStepIcon(props) {
    const classes = useColorlibStepIconStyles();
    const { active, completed } = props;
  
    const icons = {
      1: <FontAwesomeIcon icon={faUser} />
    };
  
    return (
      <div
        className={clsx(classes.root, {
          [classes.active]: active,
          [classes.completed]: completed,
        })}
      >
        {icons[String(props.icon)]}
      </div>
    );
  }
  
  ColorlibStepIcon.propTypes = {
    /**
     * Whether this step is active.
     */
    active: PropTypes.bool,
    /**
     * Mark the step as completed. Is passed to child components.
     */
    completed: PropTypes.bool,
    /**
     * The label displayed in the step icon.
     */
    icon: PropTypes.node,
  };
  
  const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    button: {
      marginRight: theme.spacing(1),
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
  }));

function getSteps() {
    return [''];
}

export const FreeSignUp = props => {

    const clubID = props.history.location.state?.clubID ? props.history.location.state.clubID : null;
    const mobileNumber = props.history.location.state?.mobileNumber ? props.history.location.state.mobileNumber : null;

    const [tcOne, setTcOne] = React.useState(false);
    const [tcTwo, setTcTwo] = React.useState(false);
    const [detailsComplete, setDetailsComplete] = React.useState(false);
    const [captcha, setCaptcha] = React.useState(false);
    const [captchaValue, setCaptchaValue] = React.useState('');

    const [detailsData, setDetailsData] = React.useState('');
    const [venue, setVenue] = React.useState('');

    const [invalidEmail, setInvalidEmail] = React.useState(true);
    const [invalidPhone, setInvalidPhone] = React.useState(true);
    const [invalidHomePhone, setInvalidHomePhone] = React.useState(true);
    const [notLoading, setNotLoading] = React.useState(true);

    const [activeStep, setActiveStep] = React.useState(0);
    const classes = useStyles();
    const steps = getSteps();


    //Referral Code
    var code = props.location.search;
    if(code){
      code = code.split('=').pop();
    }

    React.useEffect(()=>{
        if(detailsData.firstName && detailsData.lastName && detailsData.gender && detailsData.email && detailsData.dob && detailsData.mobilePhone && ((detailsData.residentialAddress && detailsData.defaultPostalAddress) || (detailsData.addressLine && detailsData.suburb && detailsData.postCode && detailsData.postCode.length === 4 && detailsData.state)) && detailsData.jobTitle.trim())
          setDetailsComplete(true);
        else
          setDetailsComplete(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [detailsData])

    function getStepContent(step) {
        switch (step) {
          case 0:
            return <PersonalDetailsPage referralCode={code} saveDetails={saveDetails} detailsData={detailsData} invalidEmail={invalidEmail} invalidHomePhone={invalidHomePhone} invalidPhone={invalidPhone} clubID={clubID} mobileNumber={mobileNumber} />;
          default:
            return 'Unknown step';
        }
    }

    const handleNext = () =>{
        switch(activeStep){
            case 0:
                signUp();
                break;
            default:
                break;
        }
    }

    const signUp = () => {
      setNotLoading(false);

      //Skip the validate address if address is manually entered
      if(!detailsData.addressLine && !detailsData.suburb && !detailsData.postCode && !detailsData.state){
        validateAddress(detailsData.defaultPostalAddress)
          .then(function (result) {
            if (result.success) {
              detailsData.postalFormat = result.format;
            }
          })
          .then(function () {
            validateAddress(detailsData.residentialAddress)
              .then(function (result) {
                if (result.success) {
                  detailsData.residentialFormat = result.format;
                  signUpSend();
                } else {
                  setNotLoading(true);
                }
              })
          });
      } else {
        signUpSend();
      }
    }

    //Handles the redirect of expired session
    const sessionRef = (node)=>{
      if(node === null){
          window.location.replace(window.location.origin);
      }
    }

    const signUpSend = () =>{
        fetch(localStorage.getItem('server') + 'member/signup', {
            method: 'POST',
            body: JSON.stringify({
                personalDetails: detailsData,
                memberVenue: venue,
                dob: String(detailsData.dob),
                referralCode: code,
                captchaValue: captchaValue,
                clubID
            })
        })
        .then(function(response){
            return response.json();
        })
        .then(function(data){
            setNotLoading(true);
            window.grecaptcha.reset();
            setCaptcha(false);

            if(data.status === 429){
                alert.show(
                    <span ref={sessionRef}>
                        Too many requests. Please try again later.
                    </span>
                    , {
                        title: "Uh Oh..."
                });
            }

            if(data.success){
              Pixel.sendTrack('Purchase', { value: 0.00, currency: 'AUD', product: 'Membership' } );
              setActiveStep((prevActiveStep) => prevActiveStep + 1);
              window.scrollTo(0, 0);
            } else if(!data.success && (data.invalidPhone || data.invalidEmail || data.invalidDOB || data.invalidDOBFormat || data.invalidHomePhone)){
                //Note this means that it is valid. For some reason I decided to make true = valid even though the const is called invalidemail -_-
                setInvalidEmail(true);
                setInvalidPhone(true);
                setInvalidHomePhone(true);
                if(data.invalidHomePhone){
                  setInvalidHomePhone(false);
                }
                if(data.invalidPhone){
                    setInvalidPhone(false);
                }
                if(data.invalidEmail){
                    setInvalidEmail(false);
                }
                setActiveStep(0);
                alert.show(<span>{data.invalidDOB && <span><p>You must be over the age of 18</p></span>}
                {data.invalidPhone && <span><p>Invalid Mobile Number Provided</p></span>}
                {data.invalidEmail && <span><p>Invalid Email Provided</p></span>}
                {data.invalidDOBFormat && <span><p>Invalid Date of Birth Format (dd/mm/yyyy)</p></span>}
                {data.invalidHomePhone && <span><p>Invalid Home Phone</p></span>}
                </span>,{
                  title: 'Invalid Details Provided'
                });
            } else if(!data.success){
                if(data.invalidCaptcha){
                  alert.show("Please try again", {
                    title: "Invalid Captcha"
                  });
                }
            }
        })
    }

    const validateAddress = (address) => {
      return new Promise(function (resolve, reject) {
        var addressQuery = address.replace(/\s/g, '%20');
        fetch(localStorage.getItem('server') + 'api/app/addressr?query=' + addressQuery, {
            method: 'GET'
          })
          .then(function (resp) {
            return resp.json();
          })
          .then(function (data) {
            data.addresses.forEach(function (result) {
              if (result.sla.replace(/ /g, "") === address.replace(/ /g, "")) {
                data = {
                  success: true,
                  format: result.pid
                }
              }
            });
            resolve(data);
          });
      })
    }

    const alert = useAlert();

    const handleBack = () => {
        switch(activeStep){
            case 0:
                redirectLogin();
                break;
            default:
                break;
        }
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const saveDetails = (formData) =>{
        setDetailsData(formData);
    }

    const redirectLogin = () =>{
        props.history.push('')
    }

    //Gets triggered when the captcha is correct and sets the captcha value
    const handleCaptcha = (value)=>{
      if(value){
        setCaptcha(true);
        setCaptchaValue(value);
      } else {
        setCaptcha(false);
      }
    }

    return(
    <div>
      <div className="overlay" hidden={notLoading}>
        <ReactLoading className="loading" type={'cylon'} color={'#61dafb'} height={300} width={300}/>
      </div>
      <div className={classes.root}>
        <div>
          {activeStep === steps.length ? (
            <div className="mini-form">
              <Typography component={'span'} className={classes.instructions}>
                <div className="welcome-div">
                  <h1 className="text-center"><strong>Welcome</strong></h1>
                  <p className="text-center">You will receive a confirmation email soon that will contain the next steps required to finalise your membership.</p>
                </div>
              </Typography>

              <br/>
              <h1 className="text-center"><strong>Download the App!</strong></h1>
              <p className="text-center">Access your digital membership with our mobile app today!</p>
              <div className="row">
                <div className="col-sm-6 text-center text-sm-left">
                  <a href="https://apps.apple.com/us/app/bankstown-sports/id1530485834" rel="noreferrer" target="_blank"><img alt="App Store" src={AppStore} /></a>
                </div>
                <div className="col-sm-6 text-center text-sm-right">
                  <a href="https://play.google.com/store/apps/details?id=com.bankstown.sportscentredroid&hl=en_AU&gl=US" rel="noreferrer" target="_blank"><img alt="Play Store" src={PlayStore} /></a>
                </div>
              </div>
              
              <button onClick={redirectLogin} className="mini-form text-center form-btn btn btn-primary d-flex justify-content-center">
                Home
              </button>
            </div>
          ) : (
            <div>
                <Typography component={'span'} className={classes.instructions}>{getStepContent(activeStep)}</Typography>
                <div hidden={activeStep === 0 ? false : true} className="container">
                    <br/>

                    <h3><strong>Preferred Venue</strong></h3>
                    <select className="formInput" value={venue} name="venue" onChange={(ev)=> setVenue(ev.currentTarget.value)}>
                      <option value="" hidden>Please Select</option>
                      <option value="1">Bankstown Sports</option>
                      <option value="2">Baulkham Hills Sports</option>
                      <option value="3">Birrong Sports</option>
                      <option value="4">Bankstown Bowls</option>
                      <option value="5">The Acres Club</option>
                      <option value="6">Auburn Tennis Club</option>
                    </select>

                    <br/>
                    <br/>

                    <h3><strong>Terms and Conditions</strong></h3>
                    <a href="https://issuu.com/bankstownsports/docs/bankstown_sports_associated_venues_-_complete_me?fr=sNWI4MjI5NzYyMjA" target="_blank" rel="noreferrer" style={{ margin: "0 0 0 25px", cursor: 'pointer'}}><strong>View Terms & Conditions</strong></a>
                    <div className="preferences">
                        <br/>
                        <label><input className="formCheck" type="checkbox" onChange={()=>setTcOne(!tcOne)} /> * I have read and understood the terms and conditions.</label>
                        <br/>
                        <label style={{ width: "90%"}} className="text-justify"><input className="formCheck" type="checkbox" onChange={()=>setTcTwo(!tcTwo)} /> * I want to become a member of Bankstown District Sports Club Ltd and request that you may enter my name in the Register of Members accordingly. I agree to be bound by the Rules, By-Laws and Regulations of the Club in force. I declare that I am over 18 years of age.</label>
                    </div>
                </div>
                <div className="step-btns">

                {activeStep === 0 && <div style={{ paddingBottom: "15px" }} className="d-flex justify-content-center"><ReCAPTCHA sitekey="6Lc6L3IUAAAAAP5lGMWMxopFktBQ4gApcNhB99Oz" onChange={handleCaptcha} /></div>}
                <Button onClick={handleBack} className={classes.button}>
                  Home
                </Button>
                <Button
                    disabled={(activeStep === 0 && tcOne && tcTwo && detailsComplete && captcha && venue) ? false : true}
                    variant="contained"
                    color="primary"
                    onClick={handleNext}
                    className={classes.button}
                >
                    Signup
                </Button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
    )
}